import React, { useState } from "react";
import { fmtDate } from "@/lib/constants";
import { resumeAlert } from "./DeliveryAlertsCard";

// Failing / Down / Paused state for one delivery place on the Manage buyer page.
export function DestAlertBanner({ alert, destId, onChanged }) {
  const [busy, setBusy] = useState(false);
  const p = alert.pause?.active ? alert.pause : null;
  const resume = async () => {
    setBusy(true);
    if (await resumeAlert(alert.id)) onChanged?.();
    setBusy(false);
  };
  if (p) {
    return (
      <div data-testid={`dest-paused-${destId}`} className="mb-2 flex flex-wrap items-center gap-2 border-2 border-zinc-800 bg-zinc-100 px-2 py-1 text-[11px]">
        <span>
          <b>Paused</b> {p.scope === "buyer" ? "— whole buyer" : "— this delivery place"} by {p.by || "staff"} · {p.held} held
          {p.rerouted ? ` · ${p.rerouted} sent to the next buyer` : ""}.{" "}
          {alert.status === "resolved" ? "A test send worked — ready to resume." : p.auto_resume ? "Turns back on by itself when a test send works." : "Resume it when it's fixed."}
        </span>
        <button type="button" onClick={resume} disabled={busy} data-testid={`dest-resume-${destId}`}
          className="ml-auto border-2 border-emerald-700 bg-emerald-700 px-2 py-0.5 text-[10px] uppercase tracking-widest text-white transition-colors duration-100 hover:bg-emerald-800 disabled:opacity-40">
          {busy ? "…" : "Resume"}
        </button>
      </div>
    );
  }
  if (alert.status !== "open") return null;
  return (
    <div data-testid={`dest-alert-${destId}`} data-level={alert.level}
      className={`mb-2 border-2 px-2 py-1 text-[11px] font-bold ${alert.level === "down" ? "border-red-700 bg-red-50 text-red-900" : "border-amber-500 bg-amber-50 text-amber-900"}`}>
      {alert.level === "down" ? "Down" : "Failing"} — {alert.streak} failed {alert.streak === 1 ? "send" : "sends in a row"}, last response {alert.last_code} ({fmtDate(alert.last_failed_at)}). Send a test after fixing it to clear this.
    </div>
  );
}
